export const useProfileStore = defineStore('profile', {
    state: () => ({
       profile: null,
    }),
    actions: {
        async updateProfile(id: string, data: any, config: any = {}) {
            const { $api } = useNuxtApp();
            return $api().v2.profile.update(id, data, config)
                .then((profile) => {
                    this.profile = profile;
                    return profile;
                });
        },
        async uploadPresentationVideo(id: string, file: File) {
            const { $api } = useNuxtApp();
            return $api().v2.profile.uploadPresentationVideo(id, file);
        },
        async deletePresentationVideo(id: string) {
            const { $api } = useNuxtApp();
            return $api().v2.profile.deletePresentationVideo(id);
        },
        async uploadAudioDemo(id: string, file: File) {
            const { $api } = useNuxtApp();
            return $api().v2.profile.uploadAudioDemo(id, file);
        },
        async deleteAudioDemo(id: string) {
            const { $api } = useNuxtApp();
            return $api().v2.profile.deleteAudioDemo(id);
        },
    }
})